import * as React from 'react';

const playbookIcon = (
  <svg
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_19929_52408)">
      <path
        d="M2.2041 1.88892H5.94816C6.61015 1.88892 7.24503 2.15189 7.71313 2.61999C8.18123 3.08809 8.4442 3.72297 8.4442 4.38496V13.1211C8.4442 12.6246 8.24697 12.1484 7.8959 11.7974C7.54482 11.4463 7.06867 11.2491 6.57217 11.2491H2.2041V1.88892Z"
        stroke="#0065FF"
        strokeWidth="1.24802"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6835 1.88892H10.9394C10.2774 1.88892 9.64253 2.15189 9.17443 2.61999C8.70633 3.08809 8.44336 3.72297 8.44336 4.38496V13.1211C8.44336 12.6246 8.64059 12.1484 8.99166 11.7974C9.34274 11.4463 9.8189 11.2491 10.3154 11.2491H14.6835V1.88892Z"
        stroke="#0065FF"
        strokeWidth="1.24802"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_19929_52408">
        <rect
          width="14.9762"
          height="14.9762"
          fill="white"
          transform="translate(0.956055 0.0170898)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default playbookIcon;
